import { createApiDescription } from "../../helperFunctions";

export const clientManagementInfo = {
    addClient: createApiDescription(
        "This API can be used to create a new client in Client Management.",
        [
            "Set type field with value 1 and MFJ field with true to add spouse details, set type field with value 2 to add entity clients.",
            "All the location details with id's can be get using All Location API.",
            "By default, the country code will be set to US (+1) if not given any value."
        ]
    ),
    allClients: createApiDescription(
        "This API can be called to get a list of clients with various filters applied in the request.",
        [
            "Client API provide results based on the given filters on the request parameters and if no filter values are given, it provides results based on default value mapped with all filters.",
            "The default number of returns in the response will be 10."
        ]
    ),
    deleteClient: createApiDescription(
        "This API can be called to delete an existing client from Client Management.",
        [
            "Unique ID can be obtained from the GET All Clients API",
            "Deleted clients will be permanently removed from Client Management"
        ]
    ),
    editClient: createApiDescription(
        "This API can be used to edit the details of the clients in the Client Management.",
        [
            "By giving empty value to the fields in the request will remove the existing value for the given fields.",
            "All the location details with id's can be get using All Location API.",
            "Country code value cannot be empty."
        ]
    ),
    uploadClientCSV: createApiDescription(
        "This API can be used to upload the clients into client management using the csv file.",
        [
            "Use separate template csv file to upload individual and entity clients.",
            "The templates can be downloaded from the client management page.",
            "The csv file should be converted into base 64 file format and give it in document field.",
            "This API supports callback mechanism."
        ]
    ),
}